import React, { useState } from "react";
import styles from "./EMICalendar.module.scss";
import { IoIosArrowDown } from "react-icons/io";

export default function EMICalendar(props) {
  const { getEmis } = props;

  const [emi, setEMI] = useState(getEmis);

  return (
    <div className={styles.emiCalendar}>
      {emi.map((item, index) => (
        <div className={styles.emiContainer} key={index}>
          <div
            className={styles.emiList}
            onClick={() =>
              setEMI((prevData) => prevData.map((item, i) => (i === index ? { ...item, show: !item.show } : item)))
            }
          >
            <div className={styles.info}>
              <div className={styles.number}>{index + 1}</div>
              <div className={styles.date}>
                {new Date(item.dueDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </div>
              <div
                className={styles.status}
                style={{
                  backgroundColor: item.bgcolor,
                  color: item.color,
                }}
              >
                {item.status}
              </div>
            </div>
            <div className={styles.price}>
              <span>₹{item.amountPayable}</span>
              <IoIosArrowDown size={15} color="#000000" />
            </div>
          </div>

          {item.show && (
            <div>
              {item.lists.map((list, index) => (
                <div className={styles.emiDetails} key={index}>
                  <div className={styles.summary} style={{ backgroundColor: list.bgcolor, color: list.color }}>
                    {list.text}
                  </div>
                  <div className={styles.emiPrice}>{list.value}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
